<template>
  <v-navigation-drawer
    app
    :mini-variant="isMinimal && !$vuetify.breakpoint.lgAndUp"
    :width="navbarWidth"
    :mini-variant-width="navbarMinWidth"
    v-model="$store.state.showDrawer"
    enable-resize-watcher
    :right="$store.state.rtl"
    :permanent="$vuetify.breakpoint.lgAndUp"
  >
    <v-layout column fill-height>
      <!-- logo -->
      <div class="px-4" style="width: 120px">
        <img
          :src="
            subscriberInfo && subscriberInfo.user && subscriberInfo.user.avatar
              ? getImage(subscriberInfo.user.avatar)
              : require('@/app/core-module/assets/images/LOGO.png')
          "
          alt="Logo"
          class="mt-6 mb-2"
          height="auto"
          width="100"
          style="max-width: 100%; object-fit: contain;"
          @click="redirect({ routeName: 'Home' })"
        />
      </div>

      <!-- minimise button -->
      <div v-if="!$vuetify.breakpoint.lgAndUp">
        <v-icon
          v-if="!$store.state.rtl"
          @click="isMinimal = !isMinimal"
          color="dark lighten-3"
          class="my-2 mx-auto"
        >
          {{
            isMinimal ? "mdi-chevron-double-right" : "mdi-chevron-double-left"
          }}
        </v-icon>

        <v-icon
          v-else
          @click="isMinimal = !isMinimal"
          color="dark lighten-3"
          class="my-2 mx-auto"
        >
          {{
            !isMinimal ? "mdi-chevron-double-right" : "mdi-chevron-double-left"
          }}
        </v-icon>
      </div>

      <!-- menu items  -->
      <v-container fluid class="fill-height pa-0 align-start mt-3">
        <v-row no-gutters justify="center" align="center">
          <v-col>
            <v-tabs
              vertical
              class="px-0 mx-0 text-align-start mb-10"
              v-model="selectedTabIndex"
              background-color="transparent"
            >
              <template v-for="(item, index) in items">
                <v-tab
                  :key="`navbar_${item.routeName}_${index}`"
                  class="px-0"
                  style="min-height: 80px"
                  @click="redirect(item)"
                >
                  <!--collapse view-->
                  <div
                    v-if="!$vuetify.breakpoint.lgAndUp"
                    style="display: contents"
                  >
                    <v-list-item
                      link
                      exact
                      :class="
                        item.routeName === $route.name ||
                        item.relatedRouteNames.includes($route.name)
                          ? 'primary--text'
                          : 'inactive'
                      "
                    >
                      <v-list-item-icon class="mx-auto pa-0">
                        <v-icon v-text="item.icon" />
                      </v-list-item-icon>

                      <v-list-item-content v-if="!isMinimal">
                        <v-list-item-title
                          class="caption font-weight-light text-start ms-2"
                        >
                          {{ item.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>

                  <!--expanded view-->
                  <div v-else :style="{ width: navbarWidth }">
                    <v-list-item
                      link
                      exact
                      :class="
                        item.routeName === $route.name ||
                        item.relatedRouteNames.includes($route.name)
                          ? 'primary--text'
                          : 'inactive'
                      "
                    >
                      <v-list-item-content align="center">
                        <v-icon v-text="item.icon" />

                        <v-list-item-title class="caption font-weight-light">
                          {{ item.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-tab>
              </template>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
      <div style="width: 100%">
        <v-divider></v-divider>
        <div>
          <div class="caption my-5 primary--text">
            <div>{{ $t("poweredBy") }}</div>
            <div>ZeroSuite</div>
          </div>
        </div>
      </div>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      isMinimal: true,
      version: "1.0",
      selectedTabIndex: 0,
      right: null,
      subscriberInfo: null,
    };
  },
  created() {
    //update languange
    if (this.$route.params.lang === "ar") {
      // i18n.locale = "ar";
      this.$vuetify.rtl = true;
      this.$store.commit("UPDATE_RTL", true);
    } else {
      // i18n.locale = "en";
      this.$vuetify.rtl = false;
      this.$store.commit("UPDATE_RTL", false);
    }
  },

  apollo: {
    getSubscriberProfile() {
      return {
        query: require("../../user-module/api/query/getSubscriberProfile.gql"),
        result({ data }) {
          if (data?.getSubscriberProfile) {
            this.subscriberInfo = data.getSubscriberProfile;
          }
        },
      };
    },
  },

  computed: {
    navbarWidth() {
      return !this.$vuetify.breakpoint.lgAndUp ? null : "120px";
    },
    navbarMinWidth() {
      return "120px";
    },
    items() {
      return [
        {
          name: this.$t("navBarItems.home"),
          icon: " mdi-home-outline",
          routeName: "Home",
          relatedRouteNames: [],
        },
        {
          name: this.$t("navBarItems.courses"),
          icon: "mdi-book-open-page-variant-outline",
          routeName: "Courses",
          relatedRouteNames: [
            "CourseDetails",
            "CourseCertificate",
            "CourseCertificateDownload",
          ],
        },
        {
          name: this.$t("quiz.assessments"),
          icon: "mdi-comment-question-outline",
          routeName: "Assessments",
          relatedRouteNames: ["AssessmentDetails"],
        },
        {
          name: this.$t("navBarItems.profile"),
          icon: "mdi-account-circle-outline",
          routeName: "Profile",
          relatedRouteNames: [],
        },
        // {
        //   name: this.$t("navBarItems.settings"),
        //   icon: "mdi-tune-vertical-variant",
        //   routeName: "",
        //   relatedRouteNames: [],
        // },
      ];
    },
  },
  watch: {
    $route: {
      handler: function (newValue) {
        this.updateTabIndex(newValue);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    redirect(item) {
      if (item.routeName !== this.$route.name)
        this.$router.push({ name: item.routeName });
    },
    updateTabIndex(route) {
      this.selectedTabIndex = this.items.findIndex(
        item =>
          item.routeName === route.name ||
          item.relatedRouteNames.includes(route.name)
      );
    },
  },
};
</script>

<style scoped>
/* nav items opacity  */
.inactive {
  color: #281166;
}

>>> .v-list-item--active {
  opacity: 1 !important;
}

/* change navifation drawer divider color */
>>> .v-navigation-drawer__border {
  background-color: rgba(0, 0, 0, 0.05) !important;
}

/* remove ligh background on selected tab */
>>> .v-list-item--link::before {
  opacity: 0 !important;
}

/* align navigation title to left */
>>> .v-tab {
  text-align: start;
}

/* tab selector shape  */
>>> .v-tabs-slider-wrapper {
  width: 4px !important;
  height: 100px !important;
  left: auto !important;
  right: 0;
}
>>> .v-tabs-slider {
  border-radius: 0 0 0 0 !important;
}
</style>
